/* eslint-disable eqeqeq */
import React, { useState, useEffect, useContext } from "react";
import Axios from "axios";
import Banner from "../Components/Banner";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { Link, useHistory, Redirect, useLocation, useParams } from "react-router-dom";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import Page from "../Components/Page";
// import { useNavigate} from "react-router"
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockIcon from "@material-ui/icons/Lock";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
function SetPassword() {
  const {path, resetId} = useParams()
  const [getId, setGetId] = useState()
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const appDispatch = useContext(DispatchContext);
  const appState = useContext(StateContext);
  const [resetValues, setResetValues] = useState({  password: "", confirmPass: "" });
  const { t } = useTranslation();

  let history = useHistory();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(true);
  };

  const handleMouseDownPassword = () => {
    setShowPassword(false);
  };


  const handleClickShowCPassword = () => {
    setShowCPassword(true);
  };

  const handleMouseDownCPassword = () => {
    setShowCPassword(false);
  };


  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  // useEffect for get resetid and decode 
  useEffect(()=> {
    var decodedStringAtoB = Buffer.from(resetId, 'base64').toString();
    setGetId(decodedStringAtoB)
  }, [])

  
  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (resetValues.password && resetValues.confirmPass !== "") {
      if(resetValues.password == resetValues.confirmPass){
        try {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}customer/update-password`,
            { id: getId, password: resetValues.password }
          );
          if (response.data.success === true) {
            setLoading(false);
            setAlertMessage({
              open: true,
              message: response.data.message,
              alertSuccess: true,
            });
            history.push("/")
          } else if (response.data.success === false) {
            setLoading(false);
            setAlertMessage({
              open: true,
              message: response.data.message,
              alertSuccess: false,
            });
          }
        } catch (e) {
          // console.log(e);
          setLoading(false);
          setAlertMessage({
            open: true,
            message: e.message,
            alertSuccess: false,
          });
        }
        
      }  
      else{
        setLoading(false);
      setAlertMessage({
        open: true,
        message: t("login.pass-not-match"),
        alertSuccess: false,
      });
      }
    } else {
      setLoading(false);
      setAlertMessage({
        open: true,
        message: t("form.plz-fill"),
        alertSuccess: false,
      });
    }
  };

  const updateField = (e) => {
    setResetValues({
      ...resetValues,
      [e.target.name]: e.target.value,
    });
  };

  // localization  start

  const arLanguageHandle = (e) => {
    // // console.log("ar change");
    appDispatch({
      type: "LangChange",
      langValue: "ar",
    });
    //   i18n.changeLanguage('ar')
  };
  const enLanguageHandle = (e) => {
    // // console.log("en change");

    appDispatch({
      type: "LangChange",
      langValue: "en",
    });
  };
 
useEffect(() =>{
    setTimeout(
      () => setAlertMessage({ open: false, message: "", alertSuccess: false }),
      8000
    );
  }, [alertMessage.open]);
  return (
    <Page title="Reset Password">
      <div>
        <div className="LoginHeader">
          <Banner
            // message_secondary={`${t("form.Welcome-Back")}!`}
            className="bannerLogin"
          />

        </div>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alertMessage.open}
          className={
            alertMessage.alertSuccess ? "success-alert" : "danger-alert"
          }
        >
          {alertMessage.alertSuccess ? (
            <Alert severity="success">{alertMessage.message}</Alert>
          ) : (
            <Alert severity="error">{alertMessage.message}</Alert>
          )}
        </Snackbar>
        <div className="LoginMainArea text-center">
          <h2>

            <span className="text-secondary">
              {" "}
              <strong> {t("login.Reset-Password")} </strong>
            </span>
          </h2>
          <form action="" onSubmit={handleSubmit}>
            
            <div
              className={`${
                appState.langValue === "ar" ? "profileformRtl" : ""
              } col-lg-4 col-md-6 px-4 mx-auto mt-3`}
            >
              <TextField
                id="password_field"
                name="password"
                value={resetValues.password}
                onChange={updateField}
                type={showPassword != true ? "password" : "text"}
                className="w-100"
                label={t("form.password")}

                InputProps={{
                
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                   style={{height:"100%",padding:"20px 14px 20px 13px"}}
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {!showPassword ? (
                          <div >
                            <VisibilityOff />
                          </div>
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
            
              />
            </div>
            
            <div
              className={`${
                appState.langValue === "ar" ? "profileformRtl" : ""
              } col-lg-4 col-md-6 px-4 mx-auto mt-3`}
            >
              <TextField
                id="confirm_pass_field"
                name="confirmPass"
                value={resetValues.confirmPass}
                onChange={updateField}
                type={showCPassword != true ? "password" : "text"}
                className="w-100"
                label={t("form.confirm-pass")}

                InputProps={{
                
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                   style={{height:"100%",padding:"20px 14px 20px 13px"}}
                        aria-label="toggle password visibility"
                        onClick={handleClickShowCPassword}
                        onMouseDown={handleMouseDownCPassword}
                        edge="end"
                      >
                        {!showCPassword ? (
                          <div >
                            <VisibilityOff />
                          </div>
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
            
              />
            </div>
            <div className="LoginButtonContainer">

              <div className={classes.root}>
                <div className={classes.wrapper}>
                  <Button
                    variant="contained"
                    className={`${buttonClassname} bg-primary login_btn`}
                    disabled={loading}
                    type="submit"
                  >
                    {loading ? t("login.redirecting") : t("login.submit")}
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}

                </div>
              </div>


              <div className="mt-3">
                <p className="small text-muted">
                 
                  {appState.langValue === "ar" ? (
                    <span
                      onClick={(e) => enLanguageHandle(e)}
                      className="cursor-pointer text-primary"
                    >
                      English
                    </span>
                  ) : (
                    <span
                      onClick={(e) => arLanguageHandle(e)}
                      className="cursor-pointer text-primary"
                    >
                      Arabic
                    </span>
                  )}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Page>
  );
}

export default withTranslation()(SetPassword);
